var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { APPEvent } from "@/events/AppEvents";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { AccessGroupState } from "./AccessgroupState";
import { AnnotationType } from "@@/Annotation";
import { PdfPageStore } from "../UIComponents/PdfPagestore";
import { isIpadScreen } from "@@/Util";
import { PdfBookmarkState } from "./PdfBookmarkState";
import { Apphandler } from "@/ipc/MainAppHandler";
export class MainViewerState {
    constructor() {
        this.activepagenumber = 1;
        this.zoomfactor = isIpadScreen() ? 1 : 0.5;
        this.loadingactivepage = false;
        this.totalpages = 0;
        this.annotate = false;
        this.viewportwidth = 0;
        this.viewportheight = 0;
        this.showbookmark = false;
        this.showaddbookmark = false;
        this.addbookmarktitle = "";
        this.addbookmarkpage = 0;
        this.addbookmarktopoffset = 0;
        this.addbookmarkleftoffset = 0;
        this.addingbookmark = false;
        this.bookmarkstate = new PdfBookmarkState();
        this.leftbookmark = window.innerWidth - 600;
        this.topbookmark = 300;
        this.deletingbookmarks = false;
        this.fileid = "";
        this.accesskey = "";
        this.pagestate = new Map();
        this.sethighlightterms = new Map();
        this.pages = new Map();
        this.accessstorestate = new AccessGroupState();
        this.shownotespanel = true;
        this.showextra = false;
        makeObservable(this);
        APPEvent.addSubscriberForDeleteBookmark((del) => {
            if (del.fileid === this.fileid) {
                console.log(del);
                for (const res of del.result) {
                    if (res.ok) {
                        this.bookmarkstate.removeBookmark(res.id);
                    }
                }
                this.setDeletingBookmarks(false);
            }
        });
        APPEvent.addSubscriberForAddBookmark((add) => {
            if (add.fileid !== this.fileid) {
                return;
            }
            if (add.bookmark) {
                add.bookmark.sortindex = this.bookmarkstate.bookmarks.size + 1;
                this.bookmarkstate.addBookmark(add.bookmark, true);
            }
            this.setShowAddBookmark(false);
            this.setAddingBookmark(false);
        });
        APPEvent.addSubscriberForPdfFilePage((res) => {
            var _a, _b, _c;
            if (res.ischooser) {
                return;
            }
            if (res.id !== PdfPageStore.activefileid) {
                return;
            }
            if (this.pagestate.has(res.pagenumber) && res.pagename !== 'summaryfile' && res.pagename !== 'keywords' &&
                !res.pagename.endsWith('-words')) {
                let page = new Uint8Array();
                if (res.page !== undefined) {
                    page = LetrwingCrypto.base64ToBin(res.page);
                }
                (_a = this.pagestate.get((res.pagenumber))) === null || _a === void 0 ? void 0 : _a.setPage(page);
                (_b = this.pagestate.get((res.pagenumber))) === null || _b === void 0 ? void 0 : _b.setPageLoading(false);
                (_c = this.pagestate.get((res.pagenumber))) === null || _c === void 0 ? void 0 : _c.setDownloadingPage(false);
                PdfPageStore.pages.set(res.pagename, page);
            }
            else if (res.pagename.endsWith('-words') && this.pagestate.has(res.pagenumber) && res.page) {
                const page = LetrwingCrypto.fromBase64ToUTF8(res.page);
                PdfPageStore.pages.set(res.pagename, page);
                const pgarr = JSON.parse(page);
                const pdet = this.pagestate.get(res.pagenumber);
                if (pdet) {
                    pdet.setWordDetails(pgarr);
                    const cods = this.sethighlightterms.get(res.pagenumber + 1);
                    if (cods !== undefined && pgarr !== undefined) {
                        const words = pgarr;
                        cods.forEach((cod) => {
                            if (words.length > cod) {
                                const wcod = words[cod];
                                const rect = {
                                    x1: wcod.x1,
                                    y1: wcod.y1,
                                    x2: wcod.x2,
                                    y2: wcod.y2
                                };
                                pdet === null || pdet === void 0 ? void 0 : pdet.setHighCods(rect);
                            }
                        });
                    }
                }
            }
            else if (res.pagename === 'bookmarks' && res.page) {
                try {
                    const page = JSON.parse(res.page);
                    this.bookmarkstate.reset();
                    this.bookmarkstate.setLoading(true);
                    if (page && page.length > 0) {
                        page.forEach((pg, index) => {
                            pg.sortindex = index + 1;
                            this.bookmarkstate.addBookmark(pg);
                        });
                    }
                    this.bookmarkstate.arrangeTree();
                    this.bookmarkstate.setLoading(false);
                }
                catch (ex) { }
            }
        });
    }
    setShowExtraOptions(show) {
        this.showextra = show;
    }
    setShowAddBookmark(show) {
        this.showaddbookmark = show;
    }
    setAddBookmarkTitle(title) {
        this.addbookmarktitle = title;
    }
    setAddingBookmark(adding) {
        this.addingbookmark = adding;
    }
    setAddBookmarkLeft(left) {
        this.addbookmarkleftoffset = left;
    }
    setAddBookmarkPage(page) {
        this.addbookmarkpage = page;
    }
    setDeletingBookmarks(deleting) {
        this.deletingbookmarks = deleting;
    }
    setAddBookmarkTop(top) {
        this.addbookmarktopoffset = top;
    }
    addBookmark() {
        if (!this.addbookmarktitle.trim()) {
            return;
        }
        if (this.addbookmarkpage < 0) {
            return;
        }
        console.log('adding bookmark');
        const bkkmark = {
            title: this.addbookmarktitle.trim(),
            top: this.addbookmarktopoffset,
            left: this.addbookmarkleftoffset,
            pagenumber: this.addbookmarkpage,
            id: '',
            parentid: this.bookmarkstate.selectedbookmark,
            sortindex: -1
        };
        const req = {
            bookmark: bkkmark,
            fileid: this.fileid,
            key: this.accesskey
        };
        console.log(req);
        this.setAddingBookmark(true);
        Apphandler.sendMessage("addbookmark", req);
    }
    deleteBookmarks() {
        if (this.bookmarkstate.hasCustomSelected()) {
            // lets now delete these gi now!
            this.setDeletingBookmarks(true);
            const req = {
                id: this.bookmarkstate.getCustomSelectedIds(),
                fileid: this.fileid
            };
            Apphandler.sendMessage("deletebookmark", req);
        }
    }
    setShowNotesPanel(show) {
        this.shownotespanel = show;
    }
    addHightlight(pg, posi) {
        var _a;
        if (!this.sethighlightterms.has(pg)) {
            this.sethighlightterms.set(pg, new Set());
        }
        (_a = this.sethighlightterms.get(pg)) === null || _a === void 0 ? void 0 : _a.add(posi);
    }
    resetHighlight() {
        this.sethighlightterms.clear();
    }
    reset() {
        this.pagestate.clear();
        this.setActivePageNumber(1);
        this.setZoomFactor(isIpadScreen() ? 1 : 0.5);
        this.setTotalPages(1);
    }
    setViewportwidth(wid) {
        this.viewportwidth = wid;
    }
    setBookmarkDialog(show) {
        this.showbookmark = show;
    }
    setViewportHeight(hg) {
        this.viewportheight = hg;
    }
    setTotalPages(pages) {
        this.totalpages = pages;
    }
    setLoadingActivePage(loading) {
        this.loadingactivepage = loading;
    }
    setActivePageNumber(num) {
        this.activepagenumber = num;
    }
    cleanup() {
    }
    setActivePageNumberStr(num) {
        this.activepagenumber = num;
    }
    redrawOngoing(color, thickness, annotationtype) {
        for (const [pg, state] of this.pagestate) {
            if (annotationtype === AnnotationType.Text) {
                state.redrawOnGoingTextAnnotation(color);
            }
            else if (annotationtype === AnnotationType.Rectangle) {
                state.redrawOnGoingRectangle(color, thickness);
            }
        }
    }
    setZoomFactor(fc) {
        this.zoomfactor = fc;
        for (const pgstate of Array.from(this.pagestate.values())) {
            pgstate.setWidth((window.innerWidth - 200) * fc);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "activepagenumber", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "zoomfactor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "loadingactivepage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "totalpages", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "annotate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "viewportwidth", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "viewportheight", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "showbookmark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "showaddbookmark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "addbookmarktitle", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "addbookmarkpage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "addbookmarktopoffset", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "addbookmarkleftoffset", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "addingbookmark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "leftbookmark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "topbookmark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "deletingbookmarks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "shownotespanel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MainViewerState.prototype, "showextra", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setShowExtraOptions", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setShowAddBookmark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setAddBookmarkTitle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setAddingBookmark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setAddBookmarkLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setAddBookmarkPage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setDeletingBookmarks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setAddBookmarkTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setViewportwidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setBookmarkDialog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setViewportHeight", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setTotalPages", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setLoadingActivePage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setActivePageNumber", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setActivePageNumberStr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MainViewerState.prototype, "setZoomFactor", null);
